import React from 'react';
import { LoaderIcon, SaveIcon } from 'lucide-react';
import { TotemPrimaryButton } from './TotemPrimaryButton';

interface TotemPrimaryLoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    loading?: boolean;
    $minWidth?: string;
    $isSecondaryStyle?: boolean;
    $isDangerStyle?: boolean;
    icon?: React.ReactNode;
    label?: string;
    useIcon?: boolean;
}

export const TotemPrimaryLoadingButton: React.FC<TotemPrimaryLoadingButtonProps> = ({
    loading = false,
    disabled,
    icon,
    label,
    useIcon = true,
    $minWidth,
    ...props
}) => {
    return (
        <TotemPrimaryButton disabled={disabled || loading} $minWidth={$minWidth} {...props}>
            {loading ? (
                <LoaderIcon className="size-4 animate-spin" />
            ) : (
                <>
                    {useIcon ? (icon ?? <SaveIcon className="size-3.5" />) : null}
                    {label ? <span>{label}</span> : null}
                </>
            )}
        </TotemPrimaryButton>
    );
};
